(function () {
  'use strict';

  function initAnnouncements(root) {
    if (!root || root.dataset.esInitialized === 'true') return;
    root.dataset.esInitialized = 'true';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-es-announcement-item]'));
    if (items.length <= 1) return;

    var index = 0;
    var autoplay = root.dataset.autoplay === 'true';
    var interval = parseInt(root.dataset.interval || '6000', 10);
    var timer = null;

    function show(nextIndex) {
      items.forEach(function (item, itemIndex) {
        var active = itemIndex === nextIndex;
        item.hidden = !active;
        requestAnimationFrame(function () {
          item.classList.toggle('is-active', active);
        });
      });
      index = nextIndex;
    }

    function next() {
      show((index + 1) % items.length);
    }

    function prev() {
      show((index - 1 + items.length) % items.length);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (autoplay && interval >= 3000) timer = window.setInterval(next, interval);
    }

    var nextButton = root.querySelector('[data-es-announcement-next]');
    var prevButton = root.querySelector('[data-es-announcement-prev]');

    if (nextButton) nextButton.addEventListener('click', function () { next(); start(); });
    if (prevButton) prevButton.addEventListener('click', function () { prev(); start(); });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    start();
  }

  function initHeader(header) {
    if (!header || header.dataset.esInitialized === 'true') return;
    header.dataset.esInitialized = 'true';

    var behavior = header.dataset.sticky || 'none';
    var wrapper = header.closest('.shopify-section') || header.parentElement;
    var lastY = window.scrollY;
    var ticking = false;

    if (wrapper) {
      wrapper.classList.toggle('es-header-section--sticky', behavior !== 'none');
      wrapper.classList.toggle('es-header-section--always', behavior === 'always');
      wrapper.classList.toggle('es-header-section--scroll-up', behavior === 'scroll-up');
    }

    function updateHeader() {
      var y = window.scrollY;
      var movingDown = y > lastY + 2;
      var movingUp = y < lastY - 2;

      header.classList.toggle('is-scrolled', y > 12);
      if (wrapper) wrapper.classList.toggle('is-scrolled', y > 12);

      if (behavior === 'scroll-up' && wrapper) {
        if (y <= 80) {
          wrapper.classList.remove('es-header-section--hidden');
        } else if (movingDown && y > 140) {
          wrapper.classList.add('es-header-section--hidden');
        } else if (movingUp) {
          wrapper.classList.remove('es-header-section--hidden');
        }
      }

      lastY = y;
      ticking = false;
    }

    if (behavior !== 'none') {
      updateHeader();
      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(updateHeader);
          ticking = true;
        }
      }, { passive: true });
    }

    var mobileMenu = header.querySelector('[data-es-mobile-menu]');
    var search = header.querySelector('[data-es-search]');

    if (mobileMenu) {
      mobileMenu.addEventListener('toggle', function () {
        if (mobileMenu.open && search && search.open) search.removeAttribute('open');
      });
    }

    if (search) {
      search.addEventListener('toggle', function () {
        if (search.open && mobileMenu && mobileMenu.open) mobileMenu.removeAttribute('open');
        if (search.open) {
          window.setTimeout(function () {
            var input = search.querySelector('input[type="search"]');
            if (input) input.focus();
          }, 80);
        }
      });
    }

    document.addEventListener('click', function (event) {
      if (search && search.open && !search.contains(event.target)) search.removeAttribute('open');
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-es-announcement]').forEach(initAnnouncements);
    (scope || document).querySelectorAll('[data-es-header]').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
